export { default } from './DetailedCarNewPdfTemplate';
